// extracted by mini-css-extract-plugin
export default {"link":"UpdatePassSuccess_link__Ve3CU"};